import { Brand_default } from "./chunk-2KVNNTNY.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/FSCCertificate/FSCCertificate.tsx
import React from "react";
import clsx from "clsx";
var FSCCertificate = _a => {
  var _b = _a,
    {
      licenseCode,
      className
    } = _b,
    rest = __objRest(_b, ["licenseCode", "className"]);
  return /* @__PURE__ */React.createElement("figure", __spreadValues({
    className: clsx("pd-w-[66px] pd-text-center pd-font-[sans-serif] pd-text-[6px] pd-leading-none", className)
  }, rest), /* @__PURE__ */React.createElement("div", {
    className: "pd-relative"
  }, /* @__PURE__ */React.createElement(Brand_default, {
    brand: "fsc-certificate-blank",
    className: "pd-h-auto pd-w-full"
  }), /* @__PURE__ */React.createElement("figcaption", {
    className: "pd-absolute pd-inset-x-0 pd-top-[55px] pd-flex pd-flex-col pd-gap-[3px] pd-text-white"
  }, /* @__PURE__ */React.createElement("span", null, "www.fsc.org"), /* @__PURE__ */React.createElement("span", {
    className: "pd-font-semibold"
  }, "FSC", /* @__PURE__ */React.createElement("sup", null, "\xAE"), " ", licenseCode))), /* @__PURE__ */React.createElement("figcaption", {
    className: "pd-mt-[6px] pd-font-semibold"
  }, "The mark of responsible forestry"));
};
var FSCCertificate_default = FSCCertificate;
export { FSCCertificate_default };